
import { useState, useEffect } from "react";
import { ContentItem } from "../types";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";
import { useAuth } from "@/contexts/AuthContext";

export function useContentLoader() {
  const [allContent, setAllContent] = useState<ContentItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { isAdmin } = useAuth();

  // Load videos from Supabase
  useEffect(() => {
    async function loadVideos() {
      try {
        setIsLoading(true);
        const { data, error } = await supabase
          .from('videos')
          .select('*')
          .order('id');
        
        if (error) {
          throw error;
        }
        
        // Convert to our content format
        const formattedContent = data.map(video => ({
          id: video.id,
          title: video.title,
          type: "video",
          credits: video.credits,
          isPublic: true,  // By default all videos are public
          isPremiere: video.is_premiere,
          fileUrl: video.url,
          duration: video.duration,
          thumbnailUrl: video.thumbnail_url
        }));
        
        setAllContent(formattedContent);
      } catch (error) {
        console.error("Error loading videos:", error);
        toast({
          title: "Σφάλμα",
          description: "Παρουσιάστηκε πρόβλημα κατά τη φόρτωση των βίντεο",
          variant: "destructive"
        });
      } finally {
        setIsLoading(false);
      }
    }
    
    loadVideos();
  }, []);

  // Filter content based on user role
  const visibleContent = isAdmin 
    ? allContent 
    : allContent.filter(item => item.isPublic);

  return { allContent: visibleContent, setAllContent, isLoading };
}
